export type AppEntry = {
  id: string;
  name: string;
  description: string;
  icon: string;
  playStoreUrl?: string;
  appStoreUrl?: string;
  websiteUrl?: string;
  comingSoon?: boolean;
};

export const apps: AppEntry[] = [
  {
    id: 'numgen-pro',
    name: 'NumGen Pro',
    description: 'Generate random groups of numbers and analyse probability to match them.',
    icon: '/apps/numgen-pro.png',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=app.dreamcode.numbergenerator&hl=en',
    appStoreUrl: 'https://apps.apple.com/us/app/numgen-pro/id6496357606',
  },
  {
    id: 'sg-bus-mrt',
    name: 'SG Bus & MRT',
    description: 'Real-time Singapore bus and MRT arrival times, nearby stops, and favourites.',
    icon: '/apps/sg-bus-mrt.png',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=app.dreamcode.sgbusandmrt',
    appStoreUrl: 'https://apps.apple.com/us/app/sg-bus-mrt/id6775866814',
  },
  {
    id: 'rain-radar',
    name: 'Rain Radar & Alerts',
    description: 'Real-time rain on your map with live radar, animated timeline, and push alerts for saved places.',
    icon: '/apps/rain-radar.png',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=app.dreamcode.raintracker',
    appStoreUrl: 'https://apps.apple.com/sg/app/rain-radar-alerts/id6780420814',
  },
  {
    id: 'snack-snake',
    name: 'Snack Snake',
    description:
      'Cute arcade snake adventure: 50 stages across five worlds, Classic mode, items, and leaderboards.',
    icon: '/apps/snack-snake.png',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=app.dreamcode.snacksnake',
    appStoreUrl: 'https://apps.apple.com/us/app/snack-snake-eat-grow/id6791991396',
  },
  {
    id: 'pdf-desk',
    name: 'PDF Desk',
    description:
      'Edit PDFs free in your browser — add text, images, shapes, and signatures; split, merge, reorder, compress, or convert to Word and Excel.',
    icon: '/apps/pdf-desk.png',
    websiteUrl: 'https://pdfdesk.net/',
  },
];
